"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const React = tslib_1.__importStar(require("react"));
const Image_1 = tslib_1.__importDefault(require("../Image"));
const PictureFrame_1 = tslib_1.__importDefault(require("../PictureFrame"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const TEXT_COLOR = '#fff';
const Wrapper = (0, styled_components_1.default)('article') `
  display: block;
  text-decoration: none;
  background: #fff;
  overflow: hidden;
  border-radius: ${(0, polished_1.rem)(4)};
`;
const Header = (0, styled_components_1.default)('header') `
  padding: 0.5em 0.7em;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  ${(0, polished_1.linearGradient)({
    colorStops: ['rgba(0,0,0,0) 0%', `rgba(0,0,0,0.8) 100%`],
})}
  font-size: ${(0, polished_1.rem)(16)};
  display: flex;
  flex-direction: column;
`;
const TITLE_FONT_SIZE = 16;
const TITLE_LINE_HEIGHT = 1.3;
const TITLE_LINES = 3;
const Title = (0, styled_components_1.default)('h2') `
  display: block;
  font-size: ${(0, polished_1.em)(TITLE_FONT_SIZE)};
  margin: 0;
  font-weight: bold;
  line-height: ${TITLE_LINE_HEIGHT};
  color: ${TEXT_COLOR};
  margin-bottom: 0.1em;
  margin-top: auto;

  display: -webkit-box;
  max-width: 100%;
  max-height: ${(0, polished_1.em)(TITLE_FONT_SIZE * TITLE_LINE_HEIGHT * TITLE_LINES -
    (TITLE_FONT_SIZE * TITLE_LINE_HEIGHT - TITLE_FONT_SIZE) / 2)};
  -webkit-line-clamp: ${TITLE_LINES};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const Subtitle = styled_components_1.default.p `
  font-size: 0.88em;
  margin: 0;
  color: ${(0, polished_1.rgba)(TEXT_COLOR, 0.75)};
`;
const CoverImage = (0, styled_components_1.default)(Image_1.default) `
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const C = props => {
    const { title, subtitle = '', imgSrc = '', className = '', fallbackImgSrc, } = props;
    return (React.createElement(Wrapper, { className: className },
        React.createElement(PictureFrame_1.default, { width: 4, height: 3 },
            React.createElement(CoverImage, { src: imgSrc, fallbackSrc: fallbackImgSrc }),
            React.createElement(Header, null,
                React.createElement(Title, null, title),
                React.createElement(Subtitle, null, subtitle)))));
};
exports.default = C;
